import { Check } from "react-feather"
import { optionOrderStatus, tradeStatus } from "../../utils"

const CallPutData = ({ data }) => {
   return (
      <table className="call-put-table">
         <thead>
            <tr>
               <th className="index">INDEX</th>
               <th></th>
               <th className="call">CALL</th>
               <th className="put">PUT</th>
            </tr>
         </thead>
         <tbody>
            <tr>
               <td className="index">High - {data?.index?.highLine}</td>
               <th>Strike Price</th>
               <td className="call">{data?.call?.brokerDetail?.tradingsymbol?.slice(-7, -2)}</td>
               <td className="put">{data?.put?.brokerDetail?.tradingsymbol?.slice(-7, -2)}</td>
            </tr>

            <tr>
               <td className="index">CLOSE 9:20 - {data?.index?.closeLine}</td>
               <th>Expiry</th>
               <td className="call">
                  {" "}
                  {data?.call?.brokerDetail?.expiry.slice(0, 2)} {data?.call?.brokerDetail?.expiry?.slice(2, 5)}{" "}
                  {data?.call?.brokerDetail?.expiry.slice(5, 9)}
               </td>
               <td className="put">
                  {data?.put?.brokerDetail?.expiry.slice(0, 2)} {data?.put?.brokerDetail?.expiry?.slice(2, 5)}{" "}
                  {data?.put?.brokerDetail?.expiry.slice(5, 9)}
               </td>
            </tr>
            <tr>
               <td className="index">Low - {data?.index?.lowLine}</td>
               <th>Lot Size</th>
               <td className="call">{data?.call?.brokerDetail?.lotsize}</td>
               <td className="put">{data?.put?.brokerDetail?.lotsize}</td>
            </tr>
            <tr>
               <td
                  className="index"
                  style={{ color: data?.index?.ltp > data?.index?.highLine ? "green" : data?.index?.ltp < data?.index?.lowLine ? "red" : "#be8f00" }}
               >
                  {data?.index?.ltp}
               </td>
               <th>ltp</th>
               <td className="call">{data?.call?.ltp}</td>
               <td className="put">{data?.put?.ltp}</td>
            </tr>
            <tr>
               <td
                  className="index"
                  style={{
                     border: data.lastIndexCloseStatus === "highLine" ? "5px solid green" : ""
                  }}
               >
                  CALL - {data?.index?.triggerValueForBuy}{" "}
                  {data.lastIndexCloseStatus === "highLine" && <Check size={16} color="green" strokeWidth={5} />}
               </td>
               <th>Trigger Value</th>
               <td className="call">{data?.call?.triggerValueForBuy}</td>
               <td className="put">{data?.put?.triggerValueForBuy}</td>
            </tr>
            <tr>
               <td
                  className="index"
                  style={{
                     border: data.lastIndexCloseStatus === "lowLine" ? "5px solid red" : ""
                  }}
               >
                  PUT - {data?.index?.triggerValueForShortSideBuy}
                  {data.lastIndexCloseStatus === "lowLine" && <Check size={16} color="red" strokeWidth={5} />}
               </td>
               <th>Target Value</th>
               <td className="call">{data?.call?.targetValue}</td>
               <td className="put">{data?.put?.targetValue}</td>
            </tr>
            <tr>
               <td className="index">High Max- {data?.index?.highLineMax}</td>
               <th>Day High</th>
               <td className="call">{data?.call?.dayHigh}</td>
               <td className="put">{data?.put?.dayHigh}</td>
            </tr>
            <tr>
               <td className="index">-----</td>
               <th>Candle High</th>
               <td className="call">{data?.call?.candleHigh}</td>
               <td className="put">{data?.put?.candleHigh}</td>
            </tr>
            <tr>
               <td className="index">Low Max- {data?.index?.lowLineMax}</td>
               <th>Stop Loss Value</th>
               <td className="call">{data?.call?.stopLossValue.toFixed(2)}</td>
               <td className="put">{data?.put?.stopLossValue.toFixed(2)}</td>
            </tr>

            <tr>
               <td className="index">----</td>
               <th>Option Status</th>
               <td className="call">{tradeStatus[data.call?.isActive]}</td>
               <td className="put">{tradeStatus[data.put?.isActive]}</td>
            </tr>
            <tr>
               <td className="index">{data.lastIndexCloseStatus}</td>
               <th>Order Status</th>
               <td className="call">{optionOrderStatus[data.call?.orderStatus]}</td>
               <td className="put">{optionOrderStatus[data.put?.orderStatus]}</td>
            </tr>
         </tbody>
      </table>
   )
}

export default CallPutData
